<template>

        <v-layout row wrap >
            <v-flex xs10 offset-xs1 >
                <v-card>                
                    <v-card-title >
                        <h2 class="grey--text text--darken-2">Profil</h2>                                                
                    </v-card-title>
                   
                    <v-divider></v-divider>
                    
                    <v-container grid-list-xs>
                        <v-layout row class="mt-2">
                            <v-flex xs4 class="layout">
                                <v-flex xs4>

                                    <v-card-media 
                                        :src= "basePath + 'storage/img/person_grey.png'"
                                        height="125px"
                                        contain
                                    ></v-card-media>
                                </v-flex>
                                <v-flex xs6>
                                    <v-flex xs12>
                                        <p>{{ title }}<br />
                                        <span>{{ authUser.forename}} {{authUser.name }}</span></p>
                                        <p>{{ authUser.email }}</p>
                                    </v-flex>
                                </v-flex>
                            
                            </v-flex>
                            <v-flex xs4 class="layout">
                                <v-layout column>
                                    <v-flex xs12>

                                        Rollen:
                                    </v-flex>
                                    <v-flex xs10 offset-xs1>
                                        <p>
                                            <span v-for="(role,i) in userRoles" :key="i">
                                                {{ role.name }} <br />
                                                (<i>{{ role.description }}</i>)
                                            </span>
                                        </p>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs4 class="layout">
                                <v-layout column>
                                    <v-flex xs12>
                                         Sprachen:
                                    </v-flex>                                
                                    <v-flex xs10 offset-xs1>
                                        <p>                                            
                                            Backend Sprache: {{ belanguage }}
                                        </p>
                                    </v-flex>    
                                    <v-flex x10 offset-xs1>
                                        <p>                                            
                                            Frontend Sprache: {{ felanguage }}
                                        </p>
                                    </v-flex>
                                </v-layout>                                
                            </v-flex>

                        </v-layout>

                    </v-container>
                    <v-card-actions>
                        <v-flex xs4 offset-xs6>
                            

                            <router-link to="/dashboard" exact>
                                <v-btn icon>
                                    <v-icon x-large class="red--text">close</v-icon>
                                </v-btn>
                            </router-link>
                        </v-flex>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
      
</template>

<script>

import formHelper from '../formHelper.vue'
export default {
     
    data() {
        return {
           titles: ['Herr','Frau']
        };
    },
    methods: {
    
            
        
    },
    mounted() {
        
        this.$store.dispatch('setAuthenticatedUser')
                
    },
    computed: {
        basePath: function() {
            return this.$axios.defaults.baseURL
        }, 
        authUser: function() {
            return this.$store.getters.authUser;
        },
        userRoles: function() {
            return this.authUser.roles.map((r)=>{
                return r
            })
        },
        title: function() {
            return this.authUser.title.name
        },
        belanguage: function() {
            return this.authUser.profiles[0].be_language.language_long
        },
        felanguage: function() {
            return this.authUser.profiles[0].fe_language.language_long
        }
        
      
    }
    
}
</script>

<style >

    
    
</style>


// WEBPACK FOOTER //
// profile.vue?255ff3cd